export default __webpack_public_path__ + "static/Slider-5c280e51fa91ec0d066894754dc880b5.mp4";